<dx-popup
  [(visible)]="visible"
  (onHiding)="handleOnHiding()"
  (onHidden)="onPopupHidden()"
  [showTitle]="false"
  [showCloseButton]="false"
  [shading]="true"
  shadingColor="rgba(0, 0, 0, 0.3)"
  [dragEnabled]="false"
  [hideOnOutsideClick]="true"
  [wrapperAttr]="{ class: 'gpd-popup' }"
  width="60vw"
  height="auto"
  [maxHeight]="'90vh'"
>
  <div class="gpd-popup-inner popup-inner">
    <div class="gpd-popup-header">
      <span class="gpd-popup-title">{{ popupTitle }}</span>
      <app-gpd-button type="text" icon="cancel" (onClick)="visible = false"></app-gpd-button>
    </div>

    <div *ngIf="editMode == false && companies !== null && persons !== null" class="popup-tab-bar">
      <button
        *ngIf="contactType == 'company' || contactType == 'all'"
        class="pnb-tab"
        [class.pnb-tab--active]="popupSelectedTab === 0"
        (click)="popupSelectedTab = 0"
        i18n="@@companies">Companies</button>
      <button
        *ngIf="contactType == 'person' || contactType == 'all'"
        class="pnb-tab"
        [class.pnb-tab--active]="popupSelectedTab === 1"
        (click)="popupSelectedTab = 1"
        i18n="@@persons">Persons</button>
      <button
        *ngIf="showSocieties"
        class="pnb-tab"
        [class.pnb-tab--active]="popupSelectedTab === societyTab"
        (click)="popupSelectedTab = societyTab"
        i18n="@@gesellschaften">Gesellschaften</button>
    </div>

    <div class="gpd-popup-body popup-body">
      <div [ngSwitch]="popupSelectedTab">

        <div *ngSwitchCase="0">
          <div [ngSwitch]="editMode">
            <div *ngSwitchCase="false">
              <dx-data-grid
                [dataSource]="companies"
                #companyGrid
                class="gpd-datagrid"
                (onRowClick)="handleContactSelected($event, 'company')"
                (onRowPrepared)="onRowPrepared($event, 'company')"
                (onCellPrepared)="onCellPrepared($event)"
                (onInitialized)="onGridInitialized('company', $event)"
                (onDisposing)="onGridDisposing('company')"
                [noDataText]="noDataText('company')"
                [showRowLines]="false"
                [rowAlternationEnabled]="false"
                [allowColumnResizing]="true"
                [columnResizingMode]="'widget'"
                [columnAutoWidth]="false"
                [showBorders]="true"
                [scrolling]="{ mode: 'standard', useNative: true }"
                [width]="'100%'"
                [hoverStateEnabled]="true">
                <dxo-header-filter [visible]="true"></dxo-header-filter>
                <dxo-scrolling mode="standard"></dxo-scrolling>
                <dxo-paging [enabled]="false"></dxo-paging>
                <dxo-toolbar>
                  <dxi-item location="before">
                    <div *dxTemplate>
                      <dx-text-box class="gpd-input" mode="search" valueChangeEvent="input" [width]="240"
                        [value]="searchText.company" (onValueChanged)="onSearchInput('company', $event.value)"
                        i18n-placeholder="@@companySearchPlaceholder" placeholder="Search name or city …">
                      </dx-text-box>
                    </div>
                  </dxi-item>
                  <dxi-item width="300px" location="before">
                    <div *ngIf="tagFilter" class="tag-box">
                      <dx-tag-box
                        i18n-placeholder placeholder="Select Tag to Filter By"
                        [(value)]="tagFilterValues"
                        [searchEnabled]="true"
                        displayExpr="title"
                        valueExpr="id"
                        acceptCustomValue="false"
                        [items]="contactTags"
                        [hideSelectedItems]="true"
                        (onSelectionChanged)="filterContactsByTag($event)"
                        [width]="300">
                      </dx-tag-box>
                    </div>
                  </dxi-item>
                  <dxi-item location="after">
                    <div *dxTemplate>
                      <app-gpd-button
                        type="primary"
                        icon="add"
                        iconColor="white"
                        i18n-text="@@addNewCompany"
                        text="Add Company"
                        (onClick)="startCreating()">
                      </app-gpd-button>
                    </div>
                  </dxi-item>
                </dxo-toolbar>
                <dxi-column dataField="displayName" i18n-caption="@@name" caption="Name"></dxi-column>
                <dxi-column dataField="city" i18n-caption="@@city" caption="City"></dxi-column>
                <!-- Server order while a search is active, see applySearch. -->
                <dxi-column name="searchRank" [visible]="false" [calculateCellValue]="companyRank"></dxi-column>
                <dxi-column
                  [allowFiltering]="true"
                  [allowHeaderFiltering]="true"
                  dataField="tags"
                  i18n-caption="@@tags"
                  caption="Tags"
                  cellTemplate="tagTemplate"
                  [calculateFilterExpression]="filterTags">
                  <dxo-lookup [dataSource]="contactTags" valueExpr="id" displayExpr="title"></dxo-lookup>
                  <div *dxTemplate="let item of 'tagTemplate'">
                    <div *ngIf="contactTags != null" class="contact-tag-container">
                      <span class="contact-tag" *ngFor="let tag of item.data.tags">{{ getTag(tag) }}</span>
                    </div>
                  </div>
                </dxi-column>
              </dx-data-grid>
            </div>
            <div *ngSwitchCase="true">
              <app-contacts-add-company-inline (onSubmit)="handleNewContactSelected($event, 'company')">
                <div class="popup-role" *ngIf="showRole">
                  <label class="popup-role__label" i18n="@@role">Role</label>
                  <div class="popup-role__divider"></div>
                  <gpd-role-select [(value)]="role" [required]="false"></gpd-role-select>
                </div>
              </app-contacts-add-company-inline>
            </div>
          </div>
        </div>

        <div *ngSwitchCase="1">
          <div [ngSwitch]="editMode">
            <div *ngSwitchCase="false">
              <dx-data-grid
                [dataSource]="persons"
                #personGrid
                class="gpd-datagrid"
                (onRowClick)="handleContactSelected($event, 'person')"
                (onRowPrepared)="onRowPrepared($event, 'person')"
                (onCellPrepared)="onCellPrepared($event)"
                [showRowLines]="false"
                [rowAlternationEnabled]="false"
                (filterValueChange)="filterValueChange($event)"
                (onInitialized)="onGridInitialized('person', $event)"
                (onDisposing)="onGridDisposing('person')"
                [noDataText]="noDataText('person')"
                [allowColumnResizing]="true"
                [columnResizingMode]="'widget'"
                [columnAutoWidth]="false"
                [showBorders]="true"
                [scrolling]="{ mode: 'standard', useNative: true }"
                [width]="'100%'"
                [hoverStateEnabled]="true">
                <dxo-header-filter [visible]="true"></dxo-header-filter>
                <dxo-scrolling mode="standard"></dxo-scrolling>
                <dxo-paging [enabled]="false"></dxo-paging>
                <dxo-toolbar>
                  <dxi-item location="before">
                    <div *dxTemplate>
                      <dx-text-box class="gpd-input" mode="search" valueChangeEvent="input" [width]="240"
                        [value]="searchText.person" (onValueChanged)="onSearchInput('person', $event.value)"
                        i18n-placeholder="@@contactSearchPlaceholder" placeholder="Search name or e-mail …">
                      </dx-text-box>
                    </div>
                  </dxi-item>
                  <dxi-item location="before" width="300px">
                    <div *ngIf="tagFilter" class="tag-box">
                      <dx-tag-box
                        i18n-placeholder placeholder="Select Tag to Filter By"
                        [(value)]="tagFilterValues"
                        [searchEnabled]="true"
                        displayExpr="title"
                        valueExpr="id"
                        acceptCustomValue="false"
                        [items]="contactTags"
                        [hideSelectedItems]="true"
                        (onSelectionChanged)="filterContactsByTag($event)"
                        [width]="300">
                      </dx-tag-box>
                    </div>
                  </dxi-item>
                  <dxi-item location="after">
                    <div *dxTemplate>
                      <app-gpd-button
                        type="primary"
                        icon="add"
                        iconColor="white"
                        i18n-text="@@addNewPersonCaps"
                        text="Add Person"
                        (onClick)="startCreating()">
                      </app-gpd-button>
                    </div>
                  </dxi-item>
                </dxo-toolbar>
                <dxi-column dataField="firstname" i18n-caption="@@firstname" caption="Firstname"></dxi-column>
                <dxi-column dataField="lastname" i18n-caption="@@lastname" caption="Lastname"></dxi-column>
                <dxi-column dataField="email" i18n-caption="@@emailAddress" caption="Email Address"></dxi-column>
                <!-- Server order while a search is active, see applySearch. -->
                <dxi-column name="searchRank" [visible]="false" [calculateCellValue]="personRank"></dxi-column>
                <dxi-column
                  [allowFiltering]="true"
                  [allowHeaderFiltering]="true"
                  dataField="tags"
                  i18n-caption="@@tags"
                  caption="Tags"
                  cellTemplate="tagTemplate"
                  [calculateFilterExpression]="filterTags">
                  <dxo-lookup [dataSource]="contactTags" valueExpr="id" displayExpr="title"></dxo-lookup>
                  <div *dxTemplate="let item of 'tagTemplate'">
                    <div *ngIf="contactTags != null" class="contact-tag-container">
                      <span class="contact-tag" *ngFor="let tag of item.data.tags">{{ getTag(tag) }}</span>
                    </div>
                  </div>
                </dxi-column>
              </dx-data-grid>
            </div>
            <div *ngSwitchCase="true">
              <app-contacts-add-person-inline (onSubmit)="handleNewContactSelected($event, 'person')">
                <div class="popup-role" *ngIf="showRole">
                  <label class="popup-role__label" i18n="@@role">Role</label>
                  <div class="popup-role__divider"></div>
                  <gpd-role-select [(value)]="role" [required]="false"></gpd-role-select>
                </div>
              </app-contacts-add-person-inline>
            </div>
          </div>
        </div>

        <!-- Gesellschaften: picked like the others; created on their own page (new browser tab). -->
        <div *ngSwitchCase="societyTab">
          <dx-data-grid
            [dataSource]="societies"
            keyExpr="id"
            class="gpd-datagrid"
            (onRowClick)="handleContactSelected($event, 'society')"
            (onRowPrepared)="onRowPrepared($event, 'society')"
            (onInitialized)="onGridInitialized('society', $event)"
            (onDisposing)="onGridDisposing('society')"
            [noDataText]="noDataText('society')"
            [showRowLines]="false"
            [rowAlternationEnabled]="false"
            [showBorders]="true"
            [scrolling]="{ mode: 'standard', useNative: true }"
            [width]="'100%'"
            [hoverStateEnabled]="true">
            <dxo-scrolling mode="standard"></dxo-scrolling>
            <dxo-paging [enabled]="false"></dxo-paging>
            <dxo-toolbar>
              <dxi-item location="before">
                <div *dxTemplate>
                  <dx-text-box class="gpd-input" mode="search" valueChangeEvent="input" [width]="240"
                    [value]="searchText.society" (onValueChanged)="onSearchInput('society', $event.value)"
                    i18n-placeholder="@@companySearchPlaceholder" placeholder="Search name or city …">
                  </dx-text-box>
                </div>
              </dxi-item>
              <dxi-item location="after">
                <div *dxTemplate>
                  <app-gpd-button
                    type="primary"
                    icon="add"
                    iconColor="white"
                    i18n-text="@@createSociety"
                    text="Gesellschaft erstellen"
                    (onClick)="createSociety()">
                  </app-gpd-button>
                </div>
              </dxi-item>
            </dxo-toolbar>
            <dxi-column dataField="displayName" i18n-caption="@@name" caption="Name"></dxi-column>
            <!-- Server order while a search is active, see applySearch. -->
            <dxi-column name="searchRank" [visible]="false" [calculateCellValue]="societyRank"></dxi-column>
          </dx-data-grid>
        </div>

      </div>
    </div>

    <div *ngIf="editMode" class="gpd-popup-footer">
      <div class="gpd-popup-footer-left"></div>
      <div class="gpd-popup-footer-right">
        <app-gpd-button type="secondary" icon="cancel" i18n-text="@@cancel" text="Abbrechen"
          (onClick)="handleAbort()"></app-gpd-button>
        <app-gpd-button type="primary" icon="check" iconColor="white" i18n-text="@@save" text="Speichern"
          (onClick)="submitInlineForm()"></app-gpd-button>
      </div>
    </div>
  </div>
</dx-popup>
